import type { ReactElement } from "react";
import { Navigate } from "react-router";

export default function IndexPage(): ReactElement {
    return <Navigate to="/support-requests/new" replace />;
}
